import { useTranslation } from 'react-i18next';

import { TimeOffRequest } from '@/modules/time-off/types/time-off-request';

import { sortTimeOffRequests } from '../../helpers/time-off-sort.helper';
import { TimeOffDetailsCard } from '../time-off/time-off-details-card';

interface TimeOffsThisMonthCardProps {
  requests: TimeOffRequest[];
}

/**
 * Month-view side-panel section mirroring `ProjectsThisMonthCard`: lists every
 * time-off request overlapping the visible month as a `TimeOffDetailsCard`
 * (without the per-day breakdown, since the whole month is in view).
 */
export function TimeOffsThisMonthCard({ requests }: TimeOffsThisMonthCardProps) {
  const { t } = useTranslation('authenticated.timeTracking');

  // PENDING first, APPROVED last — matches the calendar + week/day ordering.
  const sorted = sortTimeOffRequests(requests);

  return (
    <div className="flex w-full flex-col gap-3 rounded-lg border bg-card p-4 shadow-sm">
      <h3 className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        {t('monthView.timeOffsThisMonth.title')}
      </h3>
      {sorted.length === 0 ? (
        <p className="text-sm text-muted-foreground">{t('monthView.timeOffsThisMonth.empty')}</p>
      ) : (
        <div className="flex flex-col gap-2">
          {sorted.map(request => (
            <TimeOffDetailsCard key={request.id} request={request} />
          ))}
        </div>
      )}
    </div>
  );
}
